/* ==========================================================================
   TPSN — compare page (sections/main-compare.liquid)
   Each column: its own search over the paddle JSON, then a build picker, then
   the spec column. Spec rows are rebuilt from scratch on every change.
   Phones (< 768px) compare two paddles, desktop four — same layout otherwise.
   State lives in the URL (?c=<variant id>,<variant id>…) so a comparison can
   be shared or linked to, and survives a reload.
   ========================================================================== */
(function () {
  var root = document.querySelector('[data-cmp]');
  var dataEl = document.getElementById('tpsn-compare-data');
  if (!root || !dataEl) return;

  var products;
  try { products = JSON.parse(dataEl.textContent); } catch (e) { return; }

  /* Group each product's variants into builds (every option except Colour).
     A build shows its first AVAILABLE variant where there is one, so the
     column's image and link land on something buyable. */
  products.forEach(function (p) {
    var map = {};
    p.builds = [];
    p.variants.forEach(function (v) {
      var b = map[v.build];
      if (!b) {
        b = map[v.build] = { key: v.build, variant: v, ids: [] };
        p.builds.push(b);
      } else if (!b.variant.available && v.available) {
        b.variant = v;
      }
      b.ids.push(String(v.id));
    });
    p.hay = [p.model, p.brand, p.type, (p.tags || []).join(' '),
             p.variants.map(function (v) { return v.title; }).join(' ')].join(' ').toLowerCase();
  });

  /* The variant a column is showing: its build (shape/handle) in its chosen
     colour. Colour never changes a spec, but it does change the photo, the
     stock and what lands in the cart. */
  function cur(s) {
    for (var k = 0; k < s.p.variants.length; k++) {
      var v = s.p.variants[k];
      if (v.build === s.b.key && v.colour === s.colour) return v;
    }
    return s.b.variant;
  }

  /* Keep the column's colour when the new build comes in it, else take the
     build's own lead variant's colour (first available). */
  function setBuild(s, b) {
    var keep = s.p.variants.some(function (v) { return v.build === b.key && v.colour === s.colour; });
    s.b = b;
    if (!keep) s.colour = b.variant.colour;
  }

  function findByVariant(id) {
    for (var i = 0; i < products.length; i++) {
      var p = products[i];
      for (var j = 0; j < p.builds.length; j++) {
        if (p.builds[j].ids.indexOf(String(id)) > -1) {
          var hit = p.variants.filter(function (v) { return String(v.id) === String(id); })[0];
          return { p: p, b: p.builds[j], colour: hit ? hit.colour : p.builds[j].variant.colour };
        }
      }
    }
    return null;
  }

  /* Letter for a picker circle — mirrors snippets/shape-letter.liquid (the
     bracket wins over the whole value; exact matches only). Blank means the
     whole group falls back to text pills, as it does on the PDP. */
  function letterFor(option, value) {
    var v = String(value).toLowerCase().trim().replace(/-/g, ' ');
    if (v.indexOf('(') > -1) v = v.split('(').pop().split(')')[0].trim();
    var axis = String(option).toLowerCase();
    if (axis === 'shape') {
      if (v === 'flat top' || v === 'flattop' || v === 'flat top hybrid') return 'FT';
      if (v === 'elongated') return 'E';
      if (v === 'hybrid') return 'H';
      if (v === 'widebody' || v === 'wide body') return 'W';
    } else if (axis === 'handle') {
      if (v === 'long' || v === 'long handle') return 'L';
      if (v === 'short' || v === 'short handle' || v === 'standard' || v === 'standard handle') return 'S';
    }
    return '';
  }

  /* Shape display order FT, E, H, W, then anything else as the product has it. */
  var SHAPE_ORDER = ['FT', 'E', 'H', 'W'];

  var slots = Array.prototype.slice.call(root.querySelectorAll('.cmp__slot'));
  var specCells = Array.prototype.slice.call(root.querySelectorAll('[data-cmp-specs]'));
  var featCells = Array.prototype.slice.call(root.querySelectorAll('[data-cmp-feats]'));
  var profileCells = Array.prototype.slice.call(root.querySelectorAll('[data-cmp-profile]'));
  var barCells = Array.prototype.slice.call(root.querySelectorAll('[data-cmp-barcell]'));
  var bar = root.querySelector('[data-cmp-bar]');
  var state = slots.map(function () { return null; });

  /* Phones show the first two columns only (tpsn-compare.css hides .is-extra),
     so they hold at most two paddles. Must match the CSS breakpoint. */
  var phoneMQ = window.matchMedia('(max-width:767px)');
  var PHONE_COLS = 2;
  /* Pull the chosen paddles into the first two columns, dropping the rest —
     a four-paddle link opened on a phone shows its first two. */
  function fitPhone() {
    if (!phoneMQ.matches) return false;
    var kept = state.filter(Boolean).slice(0, PHONE_COLS);
    var changed = state.some(function (s, i) { return s !== (kept[i] || null); });
    state = state.map(function (s, i) { return kept[i] || null; });
    return changed;
  }

  /* ---------- search ---------- */

  function matches(q) {
    var words = q.toLowerCase().split(/\s+/).filter(Boolean);
    return products.filter(function (p) {
      return words.every(function (w) { return p.hay.indexOf(w) > -1; });
    });
  }

  slots.forEach(function (slot, i) {
    var input = slot.querySelector('.cmp__input');
    var list = slot.querySelector('.cmp__list');
    var active = -1;
    var shown = [];

    function open() {
      shown = matches(input.value);
      list.innerHTML = '';
      if (!shown.length) {
        var li = document.createElement('li');
        li.className = 'cmp__none';
        li.textContent = 'No paddles match';
        list.appendChild(li);
      }
      shown.forEach(function (p, n) {
        var li = document.createElement('li');
        li.id = list.id + '-' + n;
        li.setAttribute('role', 'option');
        li.className = 'cmp__opt';
        var name = document.createElement('span');
        name.textContent = p.model;
        var brand = document.createElement('span');
        brand.className = 'cmp__opt-brand';
        brand.textContent = p.brand;
        li.appendChild(name);
        li.appendChild(brand);
        /* click, not mousedown (26 Sept, Leroy on iPhone: "i cant tap on the
           quanta pro"). iOS only synthesises mousedown after the touch ends
           and can drop it, so a tap did nothing. The blur problem mousedown
           was dodging is handled on the list instead: its mousedown is
           cancelled (desktop keeps focus), and `pressing` holds the list open
           through a touch (see close-on-blur below). */
        /* ⚠ Only a press that STARTED on the list may pick (26 Sept, Leroy:
           "when i tap it, auto selects mpp turbo"). On iOS the tap on the
           field focuses it, the list opens and the page scrolls for the
           keyboard BEFORE that tap's click is delivered — so the click
           hit-tested onto the first option, now under the finger. */
        li.addEventListener('click', function () { if (pressing) choose(p); });
        list.appendChild(li);
      });
      active = -1;
      list.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    function close() {
      list.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
    }

    function highlight(n) {
      var opts = list.querySelectorAll('.cmp__opt');
      if (!opts.length) return;
      active = (n + opts.length) % opts.length;
      opts.forEach(function (o, k) { o.setAttribute('aria-selected', k === active ? 'true' : 'false'); });
      input.setAttribute('aria-activedescendant', opts[active].id);
      opts[active].scrollIntoView({ block: 'nearest' });
    }

    function choose(p) {
      var b = p.builds[0];
      /* Open on the first build that can be bought, if any can. */
      for (var k = 0; k < p.builds.length; k++) {
        if (p.builds[k].variant.available) { b = p.builds[k]; break; }
      }
      state[i] = { p: p, b: b, colour: b.variant.colour };
      input.value = '';
      close();
      render();
    }

    /* A press on the list must not close it before its click lands: on
       desktop the cancelled mousedown keeps focus in the field; on a phone,
       where the field can blur first, `pressing` skips that close. Scrolling
       the list is not a tap, so pointercancel releases it with no pick.
       ⚠ The release waits 400ms, not 0: iOS delivers the click AFTER
       pointerup, and closing first would hide the list under the finger. */
    var pressing = false;
    list.addEventListener('mousedown', function (e) { e.preventDefault(); });
    list.addEventListener('pointerdown', function () { pressing = true; });
    ['pointerup', 'pointercancel'].forEach(function (t) {
      list.addEventListener(t, function () {
        setTimeout(function () {
          pressing = false;
          if (document.activeElement !== input && !list.hidden) close();
        }, 400);
      });
    });

    input.addEventListener('focus', open);
    input.addEventListener('input', open);
    input.addEventListener('blur', function () { if (!pressing) close(); });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); if (list.hidden) open(); highlight(active + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); highlight(active - 1); }
      else if (e.key === 'Enter') {
        e.preventDefault();
        var pick = shown[active > -1 ? active : 0];
        if (pick) choose(pick);
      } else if (e.key === 'Escape') { close(); input.blur(); }
    });

    var clear = barCells[i] && barCells[i].querySelector('[data-cmp-clear]');
    if (clear) {
      clear.addEventListener('click', function () {
        state[i] = null;
        render();
        /* Not on phones: focus would raise the keyboard over a page the
           shopper may only have wanted to thin out. */
        if (!phoneMQ.matches) input.focus();
      });
    }
  });

  /* ---------- render ---------- */

  /* The PDP's option picker, rebuilt from the same classes (.picks__group,
     .pill--sw, .sw--letter, .pill--out) so it reads identically. One group per
     non-colour option. Picking a value keeps the column's other options where
     a build with that combination exists, else takes the first build that has
     the value. A value is struck when nothing with it can be bought, given the
     other options as they stand — the PDP's meaning of the strike. */
  function renderOpts(el, s, slotIndex) {
    el.innerHTML = '';
    var p = s.p;
    var curVals = s.b.variant.vals || [];
    (p.opts || []).forEach(function (name, oi) {
      var values = [];
      p.builds.forEach(function (b) {
        var val = (b.variant.vals || [])[oi];
        if (val != null && values.indexOf(val) < 0) values.push(val);
      });
      var letters = values.map(function (v) { return letterFor(name, v); });
      var circular = letters.every(Boolean);
      if (circular && name.toLowerCase() === 'shape') {
        var order = values.map(function (v, k) { return { v: v, l: letters[k], k: k }; });
        order.sort(function (a, b) {
          var ia = SHAPE_ORDER.indexOf(a.l), ib = SHAPE_ORDER.indexOf(b.l);
          return (ia < 0 ? 99 + a.k : ia) - (ib < 0 ? 99 + b.k : ib);
        });
        values = order.map(function (o) { return o.v; });
        letters = order.map(function (o) { return o.l; });
      }

      function buildFor(value, strict) {
        for (var k = 0; k < p.builds.length; k++) {
          var vals = p.builds[k].variant.vals || [];
          if (vals[oi] !== value) continue;
          if (!strict) return p.builds[k];
          var same = vals.every(function (x, j) { return j === oi || x === curVals[j]; });
          if (same) return p.builds[k];
        }
        return null;
      }

      var group = document.createElement('div');
      group.className = 'picks__group';
      group.setAttribute('data-opt-name', name.toLowerCase());
      var inner = document.createElement('div');
      inner.className = 'picks__inner';
      var label = document.createElement('div');
      label.className = 'picks__label';
      label.appendChild(document.createTextNode(name));
      if (circular) {
        var val = document.createElement('span');
        val.className = 'picks__value';
        val.textContent = curVals[oi] || '';
        label.appendChild(val);
      }
      var row = document.createElement('div');
      row.className = 'picks__row';

      values.forEach(function (value, k) {
        var target = buildFor(value, true) || buildFor(value, false);
        var buyable = p.variants.some(function (v) {
          var vals = v.vals || [];
          return v.available && vals[oi] === value &&
            vals.every(function (x, j) { return j === oi || x === curVals[j]; });
        }) || (!buildFor(value, true) && p.variants.some(function (v) {
          return v.available && (v.vals || [])[oi] === value;
        }));

        var pill = document.createElement('label');
        pill.className = 'pill' + (circular ? ' pill--sw' : '') + (buyable ? '' : ' pill--out');
        var input = document.createElement('input');
        input.type = 'radio';
        input.name = 'cmp-' + slotIndex + '-' + oi;
        input.value = value;
        input.checked = curVals[oi] === value;
        input.addEventListener('change', function () {
          if (target) { setBuild(s, target); render(); }
        });
        pill.appendChild(input);
        if (circular) {
          var sw = document.createElement('span');
          sw.className = 'sw sw--letter' + (letters[k].length > 1 ? ' sw--letter-2' : '');
          sw.setAttribute('aria-hidden', 'true');
          sw.textContent = letters[k];
          pill.appendChild(sw);
          var vh = document.createElement('span');
          vh.className = 'visually-hidden';
          vh.textContent = value + (buyable ? '' : ' (sold out)');
          pill.appendChild(vh);
          pill.title = value;
        } else {
          pill.appendChild(document.createTextNode(value));
        }
        row.appendChild(pill);
      });

      inner.appendChild(label);
      inner.appendChild(row);
      group.appendChild(inner);
      el.appendChild(group);
    });
    renderColours(el, s, slotIndex);
  }

  /* Colour, as the PDP draws it: swatch circles painted by the same
     swatch-color.liquid cascade (so two-tone colourways stay two-tone), the
     chosen name beside the label, a strike on a colour that can't be bought
     in this shape. If any colour has no paint, the row falls back to text
     pills, as the PDP does. */
  function renderColours(el, s, slotIndex) {
    var p = s.p;
    if (!p.colourName) return;
    var colours = [];
    p.variants.forEach(function (v) { if (v.colour != null && colours.indexOf(v.colour) < 0) colours.push(v.colour); });
    if (!colours.length) return;
    var sw = p.swatches || {};
    var painted = colours.every(function (c) { return !!sw[c]; });

    var group = document.createElement('div');
    group.className = 'picks__group';
    group.setAttribute('data-opt-name', 'colour');
    var inner = document.createElement('div');
    inner.className = 'picks__inner';
    var label = document.createElement('div');
    label.className = 'picks__label';
    label.appendChild(document.createTextNode(p.colourName));
    if (painted) {
      var val = document.createElement('span');
      val.className = 'picks__value';
      val.textContent = s.colour || '';
      label.appendChild(val);
    }
    var row = document.createElement('div');
    row.className = 'picks__row';

    colours.forEach(function (c) {
      var inBuild = p.variants.filter(function (v) { return v.build === s.b.key && v.colour === c; })[0];
      var buyable = !!(inBuild && inBuild.available);
      var pill = document.createElement('label');
      pill.className = 'pill' + (painted ? ' pill--sw' : '') + (buyable ? '' : ' pill--out');
      var input = document.createElement('input');
      input.type = 'radio';
      input.name = 'cmp-' + slotIndex + '-colour';
      input.value = c;
      input.checked = s.colour === c;
      input.addEventListener('change', function () {
        s.colour = c;
        /* A colour this shape doesn't come in moves the column to a shape
           that does, rather than showing a variant that doesn't exist. */
        if (!inBuild) {
          var other = p.variants.filter(function (v) { return v.colour === c; })[0];
          if (other) {
            p.builds.forEach(function (b) { if (b.key === other.build) s.b = b; });
          }
        }
        render();
      });
      pill.appendChild(input);
      if (painted) {
        var dot = document.createElement('span');
        dot.className = 'sw';
        dot.style.background = sw[c];
        pill.appendChild(dot);
        var vh = document.createElement('span');
        vh.className = 'visually-hidden';
        vh.textContent = c + (buyable ? '' : ' (sold out)');
        pill.appendChild(vh);
        pill.title = c;
      } else {
        pill.appendChild(document.createTextNode(c));
      }
      row.appendChild(pill);
    });

    inner.appendChild(label);
    inner.appendChild(row);
    group.appendChild(inner);
    el.appendChild(group);
  }

  /* ---------- buy ---------- */

  var LABEL_ADD = root.getAttribute('data-label-add') || 'Add to Cart';
  var LABEL_PRE = root.getAttribute('data-label-preorder') || 'Pre-order';
  var LABEL_NOTIFY = root.getAttribute('data-label-notify') || 'Notify me';
  var shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* The PDP's buy pill, in a column. Buyable → posts to the cart exactly as
     the product form does, including the Pre-order line item property that
     carries the ship date into checkout. Not buyable → "Notify me", which
     links to that variant's product page, where the notify form lives. */
  function renderBuy(el, s) {
    el.innerHTML = '';
    var v = cur(s);
    var btn;
    if (notifiedIds.indexOf(String(v.id)) > -1) {
      /* Back from a signup for this exact variant: the PDP's confirmation. */
      var done = document.createElement('p');
      done.className = 'cmp__done';
      done.innerHTML = '<span>You\u2019re on the list.</span> We\u2019ll email you when it lands.';
      el.appendChild(done);
      return;
    }
    btn = document.createElement('button');
    btn.type = 'button';
    if (v.available) {
      btn.addEventListener('click', function () { addToCart(btn, s, v); });
    } else {
      btn.addEventListener('click', function () { openNotify(el, s, v); });
    }
    btn.className = 'cmp__atc';
    var span = document.createElement('span');
    span.textContent = v.available ? (s.p.preorder ? LABEL_PRE : LABEL_ADD) : LABEL_NOTIFY;
    var arrow = document.createElement('i');
    arrow.setAttribute('aria-hidden', 'true');
    arrow.textContent = '\u2192';
    btn.appendChild(span);
    btn.appendChild(arrow);
    el.appendChild(btn);
    var err = document.createElement('p');
    err.className = 'cmp__err';
    err.hidden = true;
    el.appendChild(err);
  }

  /* ---------- notify me ---------- */

  /* Every variant signed up for in this tab's session (Leroy, 25 Sept): each
     signup reloads the page, and only the latest one comes back in the URL,
     so without this an earlier column lost its confirmation on the next
     signup. Session, not local, storage on purpose — a shared computer
     shouldn't show yesterday's signups as someone else's. */
  var notifiedIds = [];
  try { notifiedIds = JSON.parse(sessionStorage.getItem('cmp-notified') || '[]') || []; } catch (e) { notifiedIds = []; }

  /* Set by the fold block: re-checks the fold whenever a notify form opens or
     closes (the bar holds fully open while one is open). */
  var onNotify = function () {};
  function closeNotify(except) {
    barCells.forEach(function (c) { if (c !== except) c.classList.remove('is-notifying'); });
    onNotify();
  }

  /* Opens the column's own customer form in the pill's place, filled for the
     variant the column is showing now. One column open at a time. */
  function openNotify(buyEl, s, v) {
    var cell = buyEl.closest('[data-cmp-barcell]');
    var form = cell && cell.querySelector('[data-cmp-notify]');
    if (!form) { window.location.href = s.p.url + '?variant=' + v.id; return; }
    closeNotify(cell);
    var tags = 'bis-' + s.p.handle + (v.sku ? ',bis-' + v.sku : '') + ',marketing-optin';
    form.querySelector('[data-cmp-notify-tags]').value = tags;
    /* return_to is taken literally, so it must carry customer_posted=true
       itself (see main-product.liquid) — plus which variant signed up, so the
       right column shows the confirmation. */
    var back = new URL(window.location.href);
    back.searchParams.set('customer_posted', 'true');
    back.searchParams.set('notified', v.id);
    var ret = form.querySelector('input[name="return_to"]');
    if (ret) ret.value = back.pathname + back.search;
    form.setAttribute('data-col', cell.getAttribute('data-cmp-barcell'));
    cell.classList.add('is-notifying');
    onNotify();
    var field = form.querySelector('input[type="email"]');
    if (field) field.focus();
  }

  barCells.forEach(function (cell) {
    var form = cell.querySelector('[data-cmp-notify]');
    if (!form) return;
    form.addEventListener('submit', function () {
      try {
        sessionStorage.setItem('cmp-notify-col', form.getAttribute('data-col') || '');
        /* Where the shopper was, so the reload lands back there, not at the top. */
        sessionStorage.setItem('cmp-notify-y', String(Math.round(window.scrollY)));
      } catch (e) {}
    });
    form.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeNotify(null);
    });
  });

  /* Clicking anywhere outside an open field closes it. */
  document.addEventListener('mousedown', function (e) {
    if (e.target.closest && e.target.closest('.is-notifying')) return;
    closeNotify(null);
  });

  var peekTimer;
  function addToCart(btn, s, v) {
    var span = btn.querySelector('span');
    var was = span.textContent;
    var err = btn.parentNode.querySelector('.cmp__err');
    err.hidden = true;
    btn.disabled = true;
    var item = { id: v.id, quantity: 1 };
    if (s.p.preorder) item.properties = { 'Pre-order': s.p.shipNote || 'Ships when stock arrives' };
    fetch(shopRoot + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [item] })
    })
      .then(function (r) {
        return r.json().then(function (d) {
          /* 422 = sold out / not enough stock. Never treat it as a success. */
          if (!r.ok) throw new Error((d && (d.description || d.message)) || 'This item could not be added to your cart.');
          return d;
        });
      })
      .then(function () {
        span.textContent = 'Added to Cart \u2713';
        return refreshCart();
      })
      .then(function () {
        setTimeout(function () { span.textContent = was; }, 1800);
      })
      .catch(function (e) {
        span.textContent = was;
        err.textContent = e.message;
        err.hidden = false;
      })
      .then(function () { btn.disabled = false; });
  }

  /* Mirrors refreshCart() in tpsn.js, which isn't exposed: re-render the
     header's cart panel and the phone drawer, sync every count, then open
     this viewport's cart surface as the PDP does — the drawer below 960px,
     the desktop peek above it (closed again after the same 10s). */
  function refreshCart() {
    var fetchDoc = function (url) {
      return fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.text(); })
        .then(function (html) { return new DOMParser().parseFromString(html, 'text/html'); });
    };
    var jobs = [];
    ['.minicart__panel', '[data-cart-drawer]'].forEach(function (sel, k) {
      if (!document.querySelector(sel)) return;
      jobs.push(fetchDoc(shopRoot + '?section_id=' + (k ? 'cart-drawer' : 'header')).then(function (d) {
        var next = d.querySelector(sel), now = document.querySelector(sel);
        if (next && now) now.innerHTML = next.innerHTML;
      }));
    });
    var cartJson = fetch(shopRoot + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
    return Promise.all([Promise.all(jobs), cartJson]).then(function (done) {
      var cart = done[1];
      [].slice.call(document.querySelectorAll('[data-cart-count],[data-minicart-count]')).forEach(function (n) {
        if (n === document.body) { n.setAttribute('data-cart-count', cart.item_count); return; }
        n.textContent = cart.item_count;
      });
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      if (!window.matchMedia('(min-width:960px)').matches) {
        /* tpsn.js setState('data-cart-open', true): the attribute drives the
           drawer, and the page stops scrolling behind it. */
        document.body.setAttribute('data-cart-open', 'true');
        document.body.style.overflow = 'hidden';
      } else {
        clearTimeout(peekTimer);
        document.body.setAttribute('data-minicart-open', 'true');
        peekTimer = setTimeout(function () { document.body.removeAttribute('data-minicart-open'); }, 10000);
      }
    });
  }

  /* The spec table: each name a small caption above its value (Leroy, 25 Sept,
     "style 2" of three shown side by side), so four columns don't repeat the
     same fourteen names at full size. */
  function renderSpecTable(cell, s) {
    cell.innerHTML = '';
    if (!s) return;
    var dl = document.createElement('dl');
    dl.className = 'cmp__specs';
    (cur(s).specs || s.b.variant.specs || []).forEach(function (row) {
      var parts = String(row).split('|');
      var dt = document.createElement('dt');
      var dd = document.createElement('dd');
      dt.textContent = parts.shift() || '';
      dd.textContent = parts.join('|');
      dt.setAttribute('data-row', dt.textContent);
      dd.setAttribute('data-row', dt.textContent);
      dl.appendChild(dt);
      dl.appendChild(dd);
    });
    cell.appendChild(dl);
  }

  /* Row hover (Leroy, 25 Sept): pointing at any spec lights the same row in
     every column — bolder and a touch larger — so one attribute can be read
     straight across. Matched by label, not position, so a paddle missing a
     row can't light the wrong one. */
  var hotRow = null;
  function lightRow(label) {
    if (label === hotRow) return;
    [].forEach.call(root.querySelectorAll('.cmp__specs .is-hot, .cmp__prof .is-hot'), function (el) { el.classList.remove('is-hot'); });
    hotRow = label;
    if (label == null) return;
    [].forEach.call(root.querySelectorAll('.cmp__specs [data-row], .cmp__prof [data-row]'), function (el) {
      if (el.getAttribute('data-row') === label) el.classList.add('is-hot');
    });
  }
  root.addEventListener('mouseover', function (e) {
    var hit = e.target.closest ? e.target.closest('.cmp__specs [data-row], .cmp__prof [data-row]') : null;
    lightRow(hit ? hit.getAttribute('data-row') : null);
  });
  root.addEventListener('mouseleave', function () { lightRow(null); });

  /* ---------- TPSN Paddle Profile ----------
     Seven 1–10 ratings from TPSN's own testing, in this order. Swiftness,
     Rigidity and Feel are two-ended scales, so their ends are named under
     the bar. Anything else in the metafield is ignored rather than guessed at.
     A rating with no score reads "No data" over an empty bar (Leroy, 25 Sept)
     — every paddle shows the block, so an untested one says so plainly. */
  var PROFILE = [
    { key: 'Power' }, { key: 'Pop' }, { key: 'Control' }, { key: 'Spin' },
    { key: 'Swiftness', ends: ['Slow', 'Fast'] },
    { key: 'Rigidity', ends: ['Soft', 'Stiff'] },
    { key: 'Feel', ends: ['Dense', 'Hollow'] }
  ];
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function profileOf(s) {
    var out = {};
    (cur(s).profile || s.b.variant.profile || []).forEach(function (row) {
      var parts = String(row).split('|');
      var n = parseFloat(parts[1]);
      if (parts[0] && n >= 0 && n <= 10) out[parts[0].trim()] = n;
    });
    return out;
  }

  /* Bars fill from the left and the number counts up from 1 the first time
     the block comes into view; after that, a shape change animates from the
     old value to the new one. */
  var profileSeen = [];
  var profileIO = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      var i = profileCells.indexOf(e.target);
      profileSeen[i] = true;
      playProfile(e.target);
      profileIO.unobserve(e.target);
    });
  }, { threshold: 0.35 }) : null;

  function countTo(el, from, to, ms) {
    if (reduceMotion || from === to) { el.textContent = to; return; }
    var t0 = null;
    function step(t) {
      if (t0 === null) t0 = t;
      var p = Math.min(1, (t - t0) / ms);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(from + (to - from) * eased);
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function playProfile(cell) {
    [].forEach.call(cell.querySelectorAll('.cmp__prof-row:not(.is-nodata)'), function (row, j) {
      var to = parseFloat(row.getAttribute('data-value'));
      var from = parseFloat(row.getAttribute('data-from')) || 1;
      var fill = row.querySelector('.cmp__prof-fill');
      var num = row.querySelector('.cmp__prof-n');
      var delay = reduceMotion ? 0 : j * 90;
      setTimeout(function () {
        fill.style.width = (to * 10) + '%';
        countTo(num, from, to, 900);
      }, delay);
    });
  }

  function renderProfile(cell, s, i) {
    var prev = {};
    [].forEach.call(cell.querySelectorAll('.cmp__prof-row'), function (row) {
      prev[row.getAttribute('data-key')] = parseFloat(row.getAttribute('data-value'));
    });
    cell.innerHTML = '';
    if (!s) return;
    var data = profileOf(s);

    var wrap = document.createElement('div');
    wrap.className = 'cmp__prof';
    var head = document.createElement('div');
    head.className = 'cmp__prof-head';
    var logo = document.createElement('img');
    logo.src = root.getAttribute('data-logo-src') || '';
    logo.alt = root.getAttribute('data-logo-alt') || 'TPSN';
    logo.className = 'cmp__prof-logo';
    head.appendChild(logo);
    head.appendChild(document.createTextNode('Paddle Profile'));
    /* The scale is stated once here, not as "/10" on every row. */
    var scale = document.createElement('span');
    scale.className = 'cmp__prof-scale';
    scale.textContent = 'out of 10';
    head.appendChild(scale);
    wrap.appendChild(head);

    var seen = !!profileSeen[i];
    PROFILE.forEach(function (f) {
      var v = data[f.key];
      var none = v == null;
      var from = seen && prev[f.key] != null ? prev[f.key] : 1;
      var row = document.createElement('div');
      row.className = 'cmp__prof-row' + (none ? ' is-nodata' : '');
      row.setAttribute('data-key', f.key);
      /* Same hover as the spec rows: lights this rating in every column. */
      row.setAttribute('data-row', 'profile:' + f.key);
      if (!none) row.setAttribute('data-value', v);
      row.setAttribute('data-from', from);
      var top = document.createElement('div');
      top.className = 'cmp__prof-top';
      var name = document.createElement('span');
      name.textContent = f.key;
      var score = document.createElement('span');
      score.className = 'cmp__prof-score';
      if (none) {
        score.textContent = 'No data';
      } else {
        var n = document.createElement('b');
        n.className = 'cmp__prof-n';
        n.textContent = seen ? from : 1;
        score.appendChild(n);
      }
      top.appendChild(name);
      top.appendChild(score);
      var track = document.createElement('div');
      track.className = 'cmp__prof-track';
      track.setAttribute('role', 'img');
      track.setAttribute('aria-label', f.key + (none ? ': no data' : ' ' + v + ' out of 10') + (f.ends ? ', ' + f.ends[0] + ' to ' + f.ends[1] : ''));
      var fill = document.createElement('div');
      fill.className = 'cmp__prof-fill';
      /* Start at the old width (or empty), so the transition runs from there. */
      fill.style.width = (seen && !none ? from * 10 : 0) + '%';
      track.appendChild(fill);
      row.appendChild(top);
      row.appendChild(track);
      /* Every row carries the end-label line, empty where the scale has no
         named ends, so all six rows are one height and evenly spaced. */
      var ends = document.createElement('div');
      ends.className = 'cmp__prof-ends';
      ends.innerHTML = '<span></span><span></span>';
      if (f.ends) {
        ends.children[0].textContent = f.ends[0];
        ends.children[1].textContent = f.ends[1];
      } else {
        ends.setAttribute('aria-hidden', 'true');
      }
      row.appendChild(ends);
      wrap.appendChild(row);
    });
    cell.appendChild(wrap);

    if (seen || !profileIO) {
      void cell.offsetWidth; /* commit the start width before animating */
      playProfile(cell);
    } else {
      profileIO.observe(cell);
    }
  }

  /* The PDP feature pointers (custom.features, Title|Body), one column per
     paddle on every width. The model-name heading is hidden everywhere
     since 26 Sept (phones went half and half too); kept in the markup. */
  function renderFeatures(cell, s) {
    cell.innerHTML = '';
    if (!s || !s.p.features || !s.p.features.length) return;
    var wrap = document.createElement('div');
    wrap.className = 'cmp__feats';
    var who = document.createElement('div');
    who.className = 'cmp__feats-name';
    who.textContent = s.p.model;
    wrap.appendChild(who);
    s.p.features.forEach(function (f) {
      var parts = String(f).split('|');
      var item = document.createElement('div');
      item.className = 'cmp__feat';
      var t = document.createElement('div');
      t.className = 'cmp__feat-t';
      t.textContent = parts.shift() || '';
      var b = document.createElement('p');
      b.className = 'cmp__feat-b';
      b.textContent = parts.join('|');
      item.appendChild(t);
      item.appendChild(b);
      wrap.appendChild(item);
    });
    cell.appendChild(wrap);
  }

  function fillMeta(el, s) {
    el.querySelector('[data-cmp-name]').textContent = s.p.model;
    el.querySelector('[data-cmp-brand]').textContent = s.p.brand;
    el.querySelector('[data-cmp-price]').textContent = cur(s).price;
  }

  function renderSlot(slot, s, i) {
    var search = slot.querySelector('.cmp__search');
    var pick = slot.querySelector('.cmp__pick');
    var cell = barCells[i];
    if (specCells[i]) renderSpecTable(specCells[i], s);
    if (featCells[i]) renderFeatures(featCells[i], s);
    if (profileCells[i]) renderProfile(profileCells[i], s, i);
    /* An empty bar cell is hidden with visibility, not [hidden]: removing it
       from the grid would slide the other paddles' details one column left. */
    if (cell) {
      cell.classList.toggle('is-empty', !s);
      if (s) {
        fillMeta(cell, s);
        renderOpts(cell.querySelector('[data-cmp-opts]'), s, i);
        renderBuy(cell.querySelector('[data-cmp-buy]'), s);
      } else {
        cell.querySelector('[data-cmp-opts]').innerHTML = '';
        cell.querySelector('[data-cmp-buy]').innerHTML = '';
      }
    }
    if (!s) {
      search.hidden = false;
      pick.hidden = true;
      return;
    }
    search.hidden = true;
    pick.hidden = false;
    var v = cur(s);
    var link = pick.querySelector('[data-cmp-link]');
    link.href = s.p.url + '?variant=' + v.id;
    var img = pick.querySelector('[data-cmp-img]');
    if (v.image) { img.src = v.image; img.alt = v.alt || s.p.model; img.hidden = false; }
    else { img.removeAttribute('src'); img.hidden = true; }
    pick.querySelector('[data-cmp-badge]').textContent = s.p.badge || '';
  }

  function writeUrl() {
    var ids = state.map(function (s) { return s ? cur(s).id : ''; });
    while (ids.length && ids[ids.length - 1] === '') ids.pop();
    var url = new URL(window.location.href);
    if (ids.length) url.searchParams.set('c', ids.join(','));
    else url.searchParams.delete('c');
    history.replaceState(null, '', url.toString());
  }

  /* Set by the fold block below: re-measures the scroll-driven fold after a
     render changes the columns. ResizeObserver also covers it, but only
     reports on a rendered frame, so render() calls it directly as well. */
  var onLayout = function () {};
  function render() {
    slots.forEach(function (slot, i) { renderSlot(slot, state[i], i); });
    writeUrl();
    if (bar) bar.hidden = !state.some(Boolean);
    onLayout();
    /* Rows the feature cells span, so each pointer lines up across columns. */
    var featN = 1;
    state.forEach(function (s) { if (s && s.p.features) featN = Math.max(featN, s.p.features.length); });
    root.style.setProperty('--feat-n', featN);
    /* Phones: rows the spec cells span (a caption and a value per spec), so a
       value that wraps in one column moves the next row down in both. */
    var specN = 1;
    state.forEach(function (s) { if (s) specN = Math.max(specN, 2 * (cur(s).specs || s.b.variant.specs || []).length); });
    root.style.setProperty('--spec-n', specN);
  }

  /* .is-stuck draws the bar's bottom rule only while it is pinned, so at rest
     it reads as part of the column rather than a separate strip. */
  /* A scroll check rather than an IntersectionObserver: an observer only
     reports threshold crossings, so a jump (a link to mid-page, a reload
     partway down) that goes straight from "below" to "past" never fires it. */
  /* Scroll-linked fold (Leroy, 25 Sept). While the bar is pinned, every pixel
     scrolled down folds the options row by a pixel and every pixel scrolled
     up unfolds it, so the price and buy pill travel with the page rather than
     snapping. A timed class toggle was tried first and read as a jump: the
     fold landed all at once and left a white gap until the specs caught up.

     The fold is PAINT ONLY — a clip on the options, a translate on the price
     row and a shorter background — never layout. The bar keeps its footprint,
     so nothing below reflows and the page can't be nudged into a loop.

     It can never fold further than the distance scrolled past the pin point,
     so the bar is always fully open the moment it pins, and a jump straight
     to mid-page opens at the right amount rather than half-folded. */
  if (bar) {
    var fold = 0;
    var ticking = false;
    var lastY = window.scrollY;

    /* How far the fold travels: the options row's own track height, read off
       the bar's subgrid rows, plus TIGHTEN so the folded price row sits just
       under the brand line rather than a full price margin below it. */
    var TIGHTEN = 12;
    var foldMax = function () {
      var rows = getComputedStyle(bar).gridTemplateRows.split(' ');
      return (parseFloat(rows[1]) || 0) + TIGHTEN;
    };

    /* Phones: SCROLL-DRIVEN, not script-driven (27 Sept, Leroy). The
       script-driven fold below felt "jerky and stiff" on iPhone: the page
       scrolls on the compositor while this runs a frame or more behind on the
       main thread. A snap version was tried the same day and rejected ("just
       snaps in place, unlike our desktop"). Now, where the browser supports
       scroll-driven animations (iOS/Safari 26+, Chrome 115+), CSS runs the
       fold on the scroll timeline itself (tpsn-compare.css, .is-sda) and the
       script only hands it three numbers when layout changes: where the fold
       starts, where it ends, and how far it travels. Older browsers keep the
       script-driven fold. Position-based: it folds over the first foldMax px
       past the pin point and unfolds only on the way back up past it — unlike
       desktop, a scroll-up mid-page does not reopen it. */
    var sda = !!(window.CSS && CSS.supports && CSS.supports('animation-timeline: scroll()'));
    var sdaOn = false;
    var setSda = function () {
      var on = sda && phoneMQ.matches && !bar.hidden;
      if (on) {
        var pin = parseFloat(getComputedStyle(bar).top) || 0;
        var start = window.scrollY + slots[0].getBoundingClientRect().bottom - pin;
        var max = foldMax();
        bar.style.setProperty('--fold-a', Math.max(0, start) + 'px');
        bar.style.setProperty('--fold-b', Math.max(0, start) + max + 'px');
        bar.style.setProperty('--fold-max', max + 'px');
        bar.style.setProperty('--fold', '0px');
        bar.style.setProperty('--fold-p', '0');
        fold = 0;
      }
      if (on !== sdaOn) { sdaOn = on; bar.classList.toggle('is-sda', on); }
    };
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(function () { setSda(); });
      ro.observe(bar); ro.observe(slots[0]);
    }
    window.addEventListener('resize', setSda);
    onLayout = setSda;
    onNotify = function () { update(); };
    window.addEventListener('load', setSda);

    var update = function () {
      ticking = false;
      var pin = parseFloat(getComputedStyle(bar).top) || 0;
      var past = pin - slots[0].getBoundingClientRect().bottom;
      bar.classList.toggle('is-stuck', past > 0);

      var y = window.scrollY;
      var dy = y - lastY;
      lastY = y;
      /* A notify form open anywhere holds the bar fully open (27 Sept, Leroy's
         iPhone screenshot): the form isn't part of the fold, so folding the
         paper and lifting the price row left the email field hanging below
         the bar, mid-typing. The scroll-driven version is held by CSS
         (.cmp__bar:has(.is-notifying)). */
      if (bar.querySelector('.is-notifying')) {
        fold = 0;
        bar.style.setProperty('--fold', '0px');
        bar.style.setProperty('--fold-p', '0');
        bar.classList.remove('is-folded');
        return;
      }
      if (sdaOn) {
        /* CSS owns the motion; only the pointer-events guard follows it. */
        bar.classList.toggle('is-folded', past > foldMax() / 2);
        return;
      }
      var max = Math.min(foldMax(), Math.max(0, past));
      fold = Math.max(0, Math.min(max, fold + dy));
      bar.style.setProperty('--fold', fold + 'px');
      bar.style.setProperty('--fold-p', max ? (fold / foldMax()).toFixed(3) : '0');
      bar.classList.toggle('is-folded', fold > 0.5);
    };
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    setSda();
    update();
  }

  /* The column's name and brand grow while its photo or its bar cell is
     hovered — the product card's hover, split across the two because the
     name lives in the sticky bar, not under the photo. */
  slots.forEach(function (slot, i) {
    var cell = barCells[i];
    if (!cell) return;
    [slot.querySelector('.cmp__media'), cell].forEach(function (el) {
      if (!el) return;
      el.addEventListener('pointerenter', function () { cell.classList.add('is-hot'); });
      el.addEventListener('pointerleave', function () { cell.classList.remove('is-hot'); });
    });
  });

  /* ---------- initial state from ?c= ---------- */
  var here = new URL(window.location.href);
  var c = here.searchParams.get('c');
  if (c) {
    c.split(',').slice(0, slots.length).forEach(function (id, i) {
      if (!id) return;
      var hit = findByVariant(id);
      if (hit) state[i] = hit;
    });
  }
  /* Back from a notify signup: mark the column showing that variant, then
     drop the flags so the link is clean to share and a reload doesn't
     re-announce it. */
  var notified = here.searchParams.get('notified');
  var backFromNotify = !!notified || !!root.querySelector('[data-cmp-notify-error]');
  if (notified && here.searchParams.get('customer_posted') === 'true' && notifiedIds.indexOf(notified) < 0) {
    notifiedIds.push(notified);
    try { sessionStorage.setItem('cmp-notified', JSON.stringify(notifiedIds)); } catch (e) {}
  }
  here.searchParams.delete('notified');
  here.searchParams.delete('customer_posted');
  history.replaceState(null, '', here.toString());
  fitPhone();
  render();
  /* Narrowing a window (or turning a tablet) into the phone layout. Widening
     needs nothing: columns 3 and 4 just come back empty. */
  var onBreakpoint = function () { if (fitPhone()) render(); };
  if (phoneMQ.addEventListener) phoneMQ.addEventListener('change', onBreakpoint);
  else if (phoneMQ.addListener) phoneMQ.addListener(onBreakpoint);

  /* Back from a signup (or its error): return to the scroll position the
     form was submitted from. Photos reserve their height (width/height
     attributes on a 3:4 box), so the offset is the same page it was. */
  if (backFromNotify) {
    var y = null;
    try { y = sessionStorage.getItem('cmp-notify-y'); sessionStorage.removeItem('cmp-notify-y'); } catch (e) {}
    if (y) {
      if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
      window.scrollTo(0, parseInt(y, 10) || 0);
    }
  }

  /* A failed signup comes back as a fresh render with the error printed in
     every column's form (they share one form type). Keep it in the column
     that submitted, reopen that one, drop the rest. */
  var errs = root.querySelectorAll('[data-cmp-notify-error]');
  if (errs.length) {
    var col = null;
    try { col = sessionStorage.getItem('cmp-notify-col'); } catch (e) {}
    barCells.forEach(function (cell, i) {
      var err = cell.querySelector('[data-cmp-notify-error]');
      if (!err) return;
      if (String(i) !== col || !state[i]) { err.remove(); return; }
      var btn = cell.querySelector('.cmp__atc');
      if (btn) btn.click();
    });
  }
})();
